export const firebaseConfig = {
  apiKey: "AIzaSyA0RFQcFRsFcD9KyWni-0p2OPxZrlsncdc",
  authDomain: "kanji-sama-application.firebaseapp.com",
  projectId: "kanji-sama-application",
  storageBucket: "kanji-sama-application.appspot.com",
  messagingSenderId: "612882942672",
  appId: "1:612882942672:web:9b8459836d6b399888acd5",
  measurementId: "G-RK6EB79MCJ",
};
